import React from 'react';
import { string, bool, func } from 'prop-types';
import styles from './styles/styles.module.scss';

const CircleButton = ({ icon, large, onClick, title, className }) => {
  return (
    <button
      type="button"
      className={`${large ? styles.largeButton : styles.smallButton} ${className}`}
      aria-label={title}
      onClick={onClick}
      title={title}
      style={{ backgroundImage: `url(${icon}` }}
    />
  );
};

export default CircleButton;

CircleButton.propTypes = {
  icon: string.isRequired,
  large: bool,
  onClick: func.isRequired,
  title: string.isRequired,
  className: string
};

CircleButton.defaultProps = {
  large: false,
  className: ''
};
